import { Injectable, inject, signal } from '@angular/core';
import { ToolbarEventsService } from 'src/app/core';
import { GeneralInputButton } from '@tilby/tilby-ui-lib/models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToolbarLayoutService {

  private readonly toolbarEventsService = inject(ToolbarEventsService);

  public showModuleTitle$ = new BehaviorSubject<boolean>(true);

  /**
   * Gestione visibilità tiolo e bottoni nella toolbar in alto
   * @param allButtons Bottoni che possono stare sia nella barra che nel menu
   * @param fixedPanelButtons Bottoni che devono stare SEMPRE nel menu
   */
  updateToolbarLayout(allButtons: GeneralInputButton[], fixedPanelButtons: GeneralInputButton[] = []) {
    this.updateTitleVisibility();
    this.updateButtonsDistribution(allButtons, fixedPanelButtons);
  }

  /**
   * LOGICA SINISTRA: Gestisce la collisione tra titolo e barra di ricerca/centro
   */
  updateTitleVisibility() {
    const toolbar = document.getElementById("generalized-toolbar");
    const leftToolbar = document.getElementById("left-toolbar");
    const centerContainer = toolbar?.querySelector('[center]') as HTMLElement;
    const actualSearchBar = document.getElementById("search-bar");

    if (!toolbar || !leftToolbar || (!actualSearchBar && !centerContainer)) {
      this.showModuleTitle$.next(true);
      return;
    }

    const referenceElement = actualSearchBar || centerContainer;
    const centerRect = referenceElement.getBoundingClientRect();
    const leftRect = leftToolbar.getBoundingClientRect();
    
    const safetyMargin = 20;
    const isOverlapping = (leftRect.right + safetyMargin) > centerRect.left;

    this.showModuleTitle$.next(!isOverlapping);
  }

  /**
   * LOGICA DESTRA: Distribuisce i bottoni tra toolbar e menu a scomparsa
   */
  updateButtonsDistribution(allButtons: GeneralInputButton[], fixedPanelButtons: GeneralInputButton[] = []) {
    const toolbar = document.getElementById("generalized-toolbar");
    const centerContainer = toolbar?.querySelector('[center]') as HTMLElement;
    const actualSearchBar = document.getElementById("search-bar");

    if (!toolbar || (!actualSearchBar && !centerContainer)) return;

    const toolbarRect = toolbar.getBoundingClientRect();
    const referenceElement = actualSearchBar || centerContainer;
    const centerRect = referenceElement.getBoundingClientRect();

    const availableSpace = toolbarRect.right - centerRect.right;
    const iconWidth = 48; 
    const menuIconWidth = 48; 
    const safetyMargin = 12;  

    const netSpace = availableSpace - menuIconWidth - safetyMargin;
    let capacity = Math.max(0, Math.floor(netSpace / iconWidth));

    const activeDynamic = allButtons.filter(btn => btn.isIt());
    const activeFixed = fixedPanelButtons.filter(btn => btn.isIt());

    const barButtonsRaw = activeDynamic.slice(0, capacity);
    const overflowButtonsRaw = activeDynamic.slice(capacity);

    const barButtons = barButtonsRaw.map(btn => ({
        ...btn,
        label: signal('')
    }));

    const panelButtons = [
        ...overflowButtonsRaw, 
        ...activeFixed
    ];

    this.toolbarEventsService.buttons$.next({
        barButtons,
        panelButtons
    });
  }
}